import script from "./Nav.vue?vue&type=script&setup=true&lang=js"
export * from "./Nav.vue?vue&type=script&setup=true&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=0b70bd3c&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b70bd3c"]])

export default __exports__